import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	heading: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.plans-section.heading',
		defaultMessage: 'Plans',
		description: 'Heading for Plans settings items',
	},
	permissionsItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.plans-section.permissions-item',
		defaultMessage: 'Permissions',
		description: 'Navigation item which links to an Permissions settings page',
	},
	hierarchyItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.plans-section.hierarchy-item',
		defaultMessage: 'Hierarchy configuration',
		description: 'Navigation item which links to an Hierarchy configuration settings page',
	},
	dependenciesItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.plans-section.dependencies-item',
		defaultMessage: 'Dependencies',
		description: 'Navigation item which links to an Dependencies settings page',
	},
	loadingLimitsItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.plans-section.loading-limits-item',
		defaultMessage: 'Loading limits',
		description: 'Navigation item which links to an Loading limits settings page',
	},
	financialYearItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.plans-section.financial-year-item',
		defaultMessage: 'Financial year',
		description: 'Navigation item which links to an Financial year settings page',
	},
	archivedPlansItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.plans-section.archived-plans-item',
		defaultMessage: 'Archived plans',
		description: 'Navigation item which links to an Archived plans settings page',
	},
	archiveItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.plans-section.archive-item',
		defaultMessage: 'Archive',
		description: 'Navigation item which links to an Archived plans settings page',
	},
	trashedPlansItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.plans-section.trashed-plans-item',
		defaultMessage: 'Trash',
		description: 'Navigation item which links to an Advanced Roadmaps trashed plans settings page',
	},
});
